import { render } from "./ForgetPasswordOTP.vue?vue&type=template&id=4c1a25ae&ts=true"
import script from "./ForgetPasswordOTP.vue?vue&type=script&lang=ts"
export * from "./ForgetPasswordOTP.vue?vue&type=script&lang=ts"

import "./ForgetPasswordOTP.vue?vue&type=style&index=0&id=4c1a25ae&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__